import _typeof from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* eslint-disable */
// import { approvalMap, warning } from '../examples'
import { getWorkflowNoteInfo } from 'api/flow';
import Vue from 'vue';
var $t = Vue.prototype.$t;

// 枚举值选项
var radioInfo = [];
getWorkflowNoteInfo().then(function (res) {
  radioInfo = res.data;
});
/**
 * @description 条件组回显逻辑
 * @param { Object } item
 * @returns { String }
 */
export var handlerBranch = function handlerBranch(item) {
  // 节点和条件分支数据结构不同
  var currentData = item.form;
  // 条件组循环
  var arr = currentData.map(function (element) {
    // 条件循环
    var conditions = element.map(function (current) {
      var condition = current.condition,
        operator = current.operator,
        value = current.value;
      var state = condition && operator && value && operator.name;
      if (state) {
        return "".concat(condition.name, "  ").concat(operator.name, "  ").concat(value.name || value.value, "  ");
      }
    });
    // 输出数组转字符串
    return conditions.toString().replaceAll(',', $t('work_rule_31'));
  });
  // 输出数组转字符串
  return arr.toString().replaceAll(',', ' ' + $t('work_rule_32') + ' ');
};

/**
 * 审批人以及cc节点的处理
 * @param {*} form 当前节点form
 * @param {*} type 当前节点类型
 * @returns string
 */
var approvalCcMethods = function approvalCcMethods(form, type) {
  var dataForm = type === 1 ? form.auditor : form.cc;
  if (dataForm) {
    var labels = dataForm.map(function (item) {
      var _res$;
      // 获取label 值参考上方radioInfo
      var res = radioInfo.filter(function (el) {
        return el.type === item.settype;
      });
      var key = ((_res$ = res[0]) === null || _res$ === void 0 ? void 0 : _res$.label) || '';
      if (!key) return '';
      // 格式化返回
      var isArray = Array.isArray(item.val);
      // 数组处理
      if (isArray) {
        return "".concat(key, ": ").concat(item.val.map(function (params) {
          return params.label;
        }).toString());
      }
      // 对象或字符串
      return "".concat(key, ": ").concat(_typeof(item.val) === 'object' ? item.val.label : item.val);
    });
    return labels === null || labels === void 0 ? void 0 : labels.toString();
  }
};

// 根据不同类型解析
var mapFormate = new Map([[1, approvalCcMethods], [2, approvalCcMethods], [(3, handlerBranch)]]);
/**
 * 数据格式化处理 如果不存在则返回空字符串
 * @param {*} currentNode 当前节点数据
 * @returns
 */
var methods = function methods(currentNode) {
  var form = currentNode.form,
    type = currentNode.type;
  if (!form) return '';
  var fn = mapFormate.get(type);
  return fn ? fn(form, type) : '';
};

/**
 * 节点回显
 * @param {*} obj
 * @returns {String}
 */
export var showData = function showData(obj) {
  // 区分类型 0 发起人 1 审批人 2抄送人 3条件分支
  return methods(obj);
};